export default function ignoreCaseAndWhiteSpaceEqual(a?: string, b?: string): boolean {
  return a?.toLowerCase().trim() === b?.toLowerCase().trim();
}
